// extracted by mini-css-extract-plugin
export default {"root":"GiftGuide_root__SkG8V","star":"GiftGuide_star__2NTx_","show":"GiftGuide_show__1WbH9","starFade":"GiftGuide_starFade__1ygxa","textBanner":"GiftGuide_textBanner__2q1NL"};